import { Component, Vue, Watch } from "vue-property-decorator";
import RegisterKunjungan, { IfcRegister } from "@/store/modules/RegisterKunjungan";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import UnitJourneySvc from "@/services/UnitJourney";
import { registerSegmentUnitIds } from "@/utils/actingUnit";
import { UnitJourneySegment } from "@/types/riwayat";

@Component
export default class ActingUnitPage extends Vue {
  private periksaUnitFor: string | null = null;

  get registerAktif(): IfcRegister | null {
    return RegisterKunjungan.register;
  }

  @Watch("registerAktif")
  onRegisterForActingUnit(reg: IfcRegister | null) {
    this.validasiUnitSegmen(reg);
  }

  @Watch("$route")
  onRouteForActingUnit() {
    this.periksaUnitFor = null;
    this.validasiUnitSegmen(RegisterKunjungan.register);
  }

  mounted() {
    this.validasiUnitSegmen(RegisterKunjungan.register);
  }

  destroyed() {
    userModule.syncActingUnit(this.$router.currentRoute);
  }

  private async validasiUnitSegmen(reg: IfcRegister | null) {
    const seg = userModule.segmentUnitId;
    if (!seg) {
      this.periksaUnitFor = null;
      return;
    }

    const register = String(this.$route.params.register || "");
    if (!register) return;

    const kunci = `${register}:${seg}`;
    if (this.periksaUnitFor === kunci) return;
    this.periksaUnitFor = kunci;

    let segments: UnitJourneySegment[] = [];
    try {
      const env = await UnitJourneySvc.forRegister(register);
      segments = env.segments || [];
    } catch (e) {
      this.periksaUnitFor = null;
    }

    if (userModule.segmentUnitId !== seg) return;

    const sah = segments.length
      ? segments.map(s => (s.unit ? s.unit.id : "")).filter(Boolean)
      : registerSegmentUnitIds(reg);

    if (sah.length && !sah.includes(seg)) {
      userModule.exitActingUnit();
      appModule.sendErrorAlert(
        `Unit ${seg} bukan bagian dari kunjungan ini. Halaman dibuka dengan unit login Anda.`
      );
      this.$router
        .replace({ name: this.$route.name, params: this.$route.params })
        .catch(() => undefined);
      return;
    }

    const cocok = segments.find(s => s.unit && s.unit.id === seg);
    if (!cocok) return;

    userModule.applyActingUnitMeta({
      unitId: seg,
      unitNama: cocok.unit.nama,
      unitGroupId: cocok.unit.unit_group_id,
      zona: cocok.unit.zona
    });
  }
}
